import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
//Componentes
import CreditCard from "../CreditCard";
//Icons
import { Plus, Trash } from "@phosphor-icons/react";
//Utils
import { HandleSelectedPayment } from "utils/FunctionPayment";
//interface
import { IMethPay } from "Interfaces/IMethodPaym";

interface ICreat {
  register: any,
  errors: any,
  reset: any,
  resetField: any,
  control: any,
  getValues: any
  watch: any,
  setValue: any
  isCredit?: boolean
}

export default function CombinedPayment({
  register,
  errors,
  reset,
  resetField,
  control,
  getValues,
  watch,
  setValue,
  isCredit = true
}: ICreat) {
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [paymentAmount, setPaymentAmount] = useState<number[]>([1]);
  const [formPaymentSelecByIndex, setFormPaymentSelecByIndex] = useState<{ [key: number]: string }>({});

  const addPayment = () => {
    setPaymentAmount([...paymentAmount, paymentAmount.length + 1]);
  };

  const removePayment = (indexToRemove: number) => {
    if (paymentAmount.length > 1) {
      // Atualizar o array de pagamentos
      const updatedPayments = paymentAmount.filter((_, index) => index !== indexToRemove);
      setPaymentAmount(updatedPayments);

      // Obter os valores atuais do formulário
      const currentValues = getValues();

      // Verificar se os arrays existem antes de aplicar o filtro
      const updatedFormPaymentId = Array.isArray(currentValues.form_payment_id)
        ? currentValues.form_payment_id.filter((_: any, index: number) => index !== indexToRemove)
        : [];
      const updatedAmount = Array.isArray(currentValues.amount)
        ? currentValues.amount.filter((_: any, index: number) => index !== indexToRemove)
        : [];
      const updatedCardId = Array.isArray(currentValues.card_id)
        ? currentValues.card_id.filter((_: any, index: number) => index !== indexToRemove)
        : [];

      // Atualizar os campos com os valores filtrados
      reset({
        ...currentValues,
        form_payment_id: updatedFormPaymentId,
        amount: updatedAmount,
        card_id: updatedCardId,
      });
    }
  };

  const ModalSelectedPayment = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const result = HandleSelectedPayment(event);
    const name_payment = event.target.options[event.target.selectedIndex].text;
    setValue(`payments.down_payments.${index}.name_payment`, name_payment);
    console.log('name_payment: ', name_payment);

    if (typeof result === 'object') {
      const { name } = result;
      setFormPaymentSelecByIndex((prev) => ({
        ...prev,
        [index]: name,
      }));
    } else {
      console.log('Nenhum pagamento selecionado.');
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("payment-method");

        const paymentData = response.data.filter((val: IMethPay) => (
          val.payment_method !== 'Crediário da Loja'
        ));

        setFormPay(paymentData);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <S.Container>
      {paymentAmount.map((paymentIndex, index) => (
        <S.ContentPayment key={paymentIndex}>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label htmlFor="qtd_installment">
                Forma de Pagamento <span>*</span>
              </S.Label>
              <S.Select
                id={`payments.down_payments.${index}.payment_method_id`}
                {...register(`payments.down_payments.${index}.payment_method_id`, { required: true })}
                onChange={(e) => ModalSelectedPayment(e, index)}
              >
                <option value="" disabled selected hidden>
                  Selecione
                </option>
                {formPay.map((val) => {
                  const value = val.id;

                  return (
                    <option key={value} value={value}>
                      {val.payment_method}
                    </option>
                  );
                })}
              </S.Select>
              {errors[`payments.down_payments.${index}.payment_method_id`] && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label htmlFor={`payments.down_payments.${index}.amount`}>
                Valor <span>*</span>
              </S.Label>
              <Controller
                name={`payments.down_payments.${index}.amount`}
                rules={{ required: "Campo Obrigatório" }}
                control={control}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    className="InputDiscout"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue);
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors[`payments.down_payments.${index}.amount`] && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>
          </S.SeparateDiv>

          {formPaymentSelecByIndex[index] === "credit-card" && (
            <CreditCard
              index={index}
              register={register}
              errors={errors}
              reset={reset}
              resetField={resetField}
              subtotal={watch(`payments.down_payments.${index}.amount`) || 0}
              // responsaData={(e) => setValue(`payments.down_payments.${index}.installment_on_credit_card_id`, e)}
              responsaData={(id, interestRate, parcela) => {
                setValue(`payments.down_payments.${index}.installment_on_credit_card_id`, id);
                setValue(`payments.down_payments.${index}.installment_interest_rate`, interestRate);
                setValue(`payments.down_payments.${index}.number_installment`, parcela);
              }}
            />
          )}

          {paymentAmount.length > 1 && (
            <S.ContentButton>
              <S.ButtonRemove
                type="button"
                onClick={() => removePayment(index)}
              >
                <Trash />
                Remover
              </S.ButtonRemove>
            </S.ContentButton>
          )}
        </S.ContentPayment>
      ))}

      <S.ContentButton>
        <S.Button
          type="button"
          onClick={addPayment}
        >
          <Plus size={16} />
          Pagamento
        </S.Button>
      </S.ContentButton>
    </S.Container>
  );
}
